import { FiChevronDown } from 'react-icons/fi';
export default FiChevronDown;

//# sourceMappingURL=ChevronDown.js.map